/**
 * Proposal provenance — where a server-stored proposal came from, derived from
 * its `proposed_by` stamp (no schema column). The signal→proposal bridge stamps
 * a fixed sentinel string; the chat path stamps the operator's auth.sub. A human
 * principal's sub/email can never equal the constant, so this is a lossless,
 * non-brittle discriminator. Single source of truth for the ops side (the api
 * constant lives in avery/bridge.ts; packages can't share the import).
 */

/** Mirrors PROPOSED_BY_SENTINEL_BRIDGE in parkify-pay/api/src/avery/bridge.ts. */
export const PROPOSED_BY_SENTINEL_BRIDGE = 'avery-sentinel-bridge'
/** Mirrors PROPOSED_BY_CONTRACT_BRIDGE in parkify-pay/api/src/payments/connect_contract.ts. */
export const PROPOSED_BY_CONTRACT_BRIDGE = 'avery-contract-bridge'
/** Mirrors PROPOSED_BY_PDF_EXTRACTION in parkify-pay/api/src/avery/contract_extraction.ts. */
export const PROPOSED_BY_PDF_EXTRACTION = 'avery-pdf-extraction'

export function proposalSource(proposedBy: string | null | undefined): { label: string; kind: 'bridge' | 'chat' } {
  if (proposedBy === PROPOSED_BY_SENTINEL_BRIDGE) return { label: 'From overnight signals', kind: 'bridge' }
  if (proposedBy === PROPOSED_BY_CONTRACT_BRIDGE) return { label: 'From signed contract', kind: 'bridge' }
  if (proposedBy === PROPOSED_BY_PDF_EXTRACTION) return { label: 'From uploaded PDF', kind: 'bridge' }
  return { label: 'From chat', kind: 'chat' }
}
